import { Run } from '@bringg/types';

import { useStores } from 'bringg-web/recipes';
import { getRouteTasks } from '../utils/route-utils';

export const useRouteTrailer = (route: Run) => {
	const { vehiclesStore } = useStores();

	const tasks = getRouteTasks(route?.id);

	if (!route || !tasks.length) {
		return { trailerId: null, trailerName: null };
	}

	const taskInRun = tasks[0];

	const trailerId = taskInRun && taskInRun.vehicle_id !== route.vehicle_id ? taskInRun.vehicle_id : null;
	const trailerName = trailerId ? vehiclesStore.get(trailerId)?.name || null : null;

	return { trailerId, trailerName };
};
